import type {ServerWebExchangeMatcherEntry} from '../util/matchers.ts';
import {type Authentication, AuthorizationDecision, type AuthorizationManager, DefaultAuthorizationManager} from './types.ts';
import getLogger from '../../logger.ts';
import type {ServerWebExchange} from '../../../types/web/server';

const logger = getLogger('security.auth');

export default function delegatingAuthorizationManager(opts: {mappings: Array<ServerWebExchangeMatcherEntry<AuthorizationManager<{ exchange: ServerWebExchange }>>>}) {
    const check = async (authentication: Promise<Authentication | undefined>, exchange: ServerWebExchange): Promise<AuthorizationDecision> => {
        let decision: AuthorizationDecision;
        for (const [matcher, manager] of opts.mappings) {
            if ((await matcher(exchange))?.match) {
                logger.debug(`checking authorization on '${exchange.request.path}' using [${matcher}, ${manager}]`);
                const checkResult = await manager.authorize(authentication, {exchange});
                if (checkResult !== undefined) {
                    decision = checkResult;
                    break;
                }
            }
        }
        decision ??= new AuthorizationDecision(false);
        return decision;

    }
    return new DefaultAuthorizationManager(check);
}
